import React from "react";
import PropTypes from "prop-types";
import "./subsidy-benefit-amount-card.scss";

const SubsidyBenefitAmountCard = ({ hidden, title, children }) => {
  return (
    <div hidden={hidden} className="subsidy-benefit-amount-card">
      <div className="header">
        <p>{title}</p>
      </div>
      <div className="content">{children}</div>
    </div>
  );
};

SubsidyBenefitAmountCard.defaultProps = { hidden: false };
SubsidyBenefitAmountCard.propTypes = {
  hidden: PropTypes.bool,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default SubsidyBenefitAmountCard;
